import React from 'react';
import { LazyLoadingComponent } from '@/../LazyLoading';
import config from '@/configs/config';

export default function Image({
  single = false,
  urls = '',
  className = '',
}) {
  return (
    <div className={`default-image ${className}`}>
      <LazyLoadingComponent>
        {
          urls.split('+').map((url, index) => {
            if (index > 0 && single) return null;
            return <img src={`${config.RESOURCE_URI}${url}`} alt="" className="inner-image" key={url} />;
          })
        }
      </LazyLoadingComponent>
    </div>
  );
}
